import config from 'config'
import React from 'react'
import { get } from 'lodash'
import ExpiredWWC from '../../components/layout/ExpiredWWC/ExpiredWWC'
import { PendingWWC } from '../../components/layout'

const urlPrefix = `${config.publicPath}/assessor`

export default [
  {
    path: `${urlPrefix}/expired-wwc`,
    component: props => (
      <ExpiredWWC
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/pending-wwc`,
    exact: true,
    component: props => (
      <PendingWWC
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  }
]
